module.exports = __webpack_public_path__ + "media/images/icon/icon_g2-01503c21a0a4e4be2a03952b5ff348ec.png";